import { getEntityPageUrl } from '@/features/statisticsPage/utils';

export const ROUTE_PATH = getEntityPageUrl('anonymous_purchases');

export const FEATURE_NAME = 'anonymousPurchasesStatisticsPage';
